import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AuditLog } from '../models/audit-log';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {
   
  private baseUrl = `${environment.smartPortalApiUrl}auditlog`;

  constructor(private http: HttpClient) {}

  getAuditLogs2(filters: any): Observable<AuditLog[]> {
    return this.http.get<AuditLog[]>(this.baseUrl, { params: filters });
  }

  getAuditLogs(filters: any): Observable<any> {
   
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined) {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get<any>(`${this.baseUrl}`, { params });
  }
}
